import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'border-b border-background-200/80 bg-background-50/95 backdrop-blur-md'
          : 'border-b border-transparent bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:h-20 md:px-8">
        <a href="#top" className="group flex items-center gap-3">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md transition-colors md:h-10 md:w-10 ${
              scrolled ? 'bg-primary-500 text-background-50' : 'bg-background-50/20 text-background-50'
            }`}
          >
            <i className="ri-alarm-warning-line text-lg md:text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg font-black tracking-wide transition-colors md:text-xl ${
                scrolled ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              私照外泄
            </span>
            <span
              className={`mt-1 text-[10px] font-medium tracking-[0.28em] transition-colors ${
                scrolled ? 'text-primary-600' : 'text-accent-300'
              }`}
            >
              EVENT&nbsp;ARCHIVE
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                scrolled
                  ? 'text-foreground-700 hover:bg-background-100 hover:text-primary-600'
                  : 'text-background-100 hover:bg-background-50/15 hover:text-background-50'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#tip"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            我要爆料
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-md transition-colors lg:hidden ${
              scrolled ? 'text-foreground-900 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/15'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-base text-foreground-400" />
              </a>
            ))}
            <a
              href="#tip"
              onClick={() => setMenuOpen(false)}
              className="mt-2 inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
            >
              我要爆料
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}